import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var REACT_ELEMENT_TYPE;

function _jsx2(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

import PropTypes from 'prop-types';
import React from 'react';
import { Animated, Platform, processColor, StyleSheet } from 'react-native';
import createNativeWrapper from './createNativeWrapper';
import GestureHandlerButton from './GestureHandlerButton';
import State from './State';
export const RawButton = createNativeWrapper(GestureHandlerButton, {
  shouldCancelWhenOutside: false,
  shouldActivateOnStart: false
});
/* Buttons */

export class BaseButton extends React.Component {
  constructor(props) {
    super(props);

    this._handleEvent = ({
      nativeEvent
    }) => {
      const {
        state,
        oldState,
        pointerInside
      } = nativeEvent;
      const active = pointerInside && state === State.ACTIVE;

      if (active !== this._lastActive && this.props.onActiveStateChange) {
        this.props.onActiveStateChange(active);
      }

      if (oldState === State.ACTIVE && state !== State.CANCELLED && this._lastActive && this.props.onPress) {
        this.props.onPress(active);
      }

      this._lastActive = active;
    };

    this._onHandlerStateChange = e => {
      this.props.onHandlerStateChange && this.props.onHandlerStateChange(e);

      this._handleEvent(e);
    };

    this._onGestureEvent = e => {
      this.props.onGestureEvent && this.props.onGestureEvent(e);

      this._handleEvent(e);
    };

    this._lastActive = false;
  }

  render() {
    const {
      rippleColor,
      ...rest
    } = this.props;
    return /*#__PURE__*/_jsx(RawButton, {
      rippleColor: processColor(rippleColor),
      ...rest,
      onGestureEvent: this._onGestureEvent,
      onHandlerStateChange: this._onHandlerStateChange
    });
  }

}
BaseButton.propTypes = { ...RawButton.propTypes,
  onPress: PropTypes.func,
  onActiveStateChange: PropTypes.func
};
const AnimatedBaseButton = Animated.createAnimatedComponent(BaseButton);
const btnStyles = StyleSheet.create({
  underlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
});
export class RectButton extends React.Component {
  constructor(props) {
    super(props);

    this._onActiveStateChange = active => {
      if (Platform.OS !== 'android') {
        this._opacity.setValue(active ? this.props.activeOpacity : 0);
      }

      this.props.onActiveStateChange && this.props.onActiveStateChange(active);
    };

    this._opacity = new Animated.Value(0);
  }

  render() {
    const {
      children,
      style,
      ...rest
    } = this.props;
    const resolvedStyle = StyleSheet.flatten(style !== null && style !== void 0 ? style : {});
    return /*#__PURE__*/_jsxs(BaseButton, { ...rest,
      style: resolvedStyle,
      onActiveStateChange: this._onActiveStateChange,
      children: [/*#__PURE__*/_jsx2(Animated.View, {
        style: [btnStyles.underlay, {
          opacity: this._opacity,
          backgroundColor: this.props.underlayColor,
          borderRadius: resolvedStyle.borderRadius,
          borderTopLeftRadius: resolvedStyle.borderTopLeftRadius,
          borderTopRightRadius: resolvedStyle.borderTopRightRadius,
          borderBottomLeftRadius: resolvedStyle.borderBottomLeftRadius,
          borderBottomRightRadius: resolvedStyle.borderBottomRightRadius
        }]
      }), children]
    });
  }

}
RectButton.propTypes = BaseButton.propTypes;
RectButton.defaultProps = {
  activeOpacity: 0.105,
  underlayColor: 'black'
};
export class BorderlessButton extends React.Component {
  constructor(props) {
    super(props);

    this._onActiveStateChange = active => {
      if (Platform.OS !== 'android') {
        this._opacity.setValue(active ? this.props.activeOpacity : 1);
      }

      this.props.onActiveStateChange && this.props.onActiveStateChange(active);
    };

    this._opacity = new Animated.Value(1);
  }

  render() {
    const {
      children,
      style,
      ...rest
    } = this.props;
    return /*#__PURE__*/_jsx(AnimatedBaseButton, { ...rest,
      onActiveStateChange: this._onActiveStateChange,
      style: [style, Platform.OS === 'ios' && {
        opacity: this._opacity
      }],
      children: children
    });
  }

}
BorderlessButton.propTypes = { ...BaseButton.propTypes,
  borderless: PropTypes.bool
};
BorderlessButton.defaultProps = {
  activeOpacity: 0.3,
  borderless: true
};
export { default as PureNativeButton } from './GestureHandlerButton';